import { render, staticRenderFns } from "./productDoc.vue?vue&type=template&id=07bfd264&scoped=true"
import script from "./productDoc.vue?vue&type=script&lang=ts"
export * from "./productDoc.vue?vue&type=script&lang=ts"
import style0 from "./productDoc.vue?vue&type=style&index=0&id=07bfd264&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bfd264",
  null
  
)

export default component.exports